<template>
  <div class="login-body">
    <Toast />
    <div class="login-image"></div>
    <div class="card login-panel p-fluid">
      <div class="login-panel-content">
        <div class="p-grid">
          <div class="p-col-3" style="text-align:left">
            <img src="img/Logo-HTP-Circle.png" height="90px" alt="avalon-vue"/>
          </div>
          <div class="p-col-9" style="text-align:left">
            <h2 class="welcome-text">Forgot Password</h2>
            <span class="guest-sign-in">Password reset for your TIMS account</span>
          </div>
          <div class="p-col-12" style="text-align:left">
            <label class="login-label">User ID</label>
            <div class="login-input">
              <InputText name="user_id" v-model="input.user_id.value" placeholder="User ID" v-bind:class="{ 'p-error': input.user_id.errMsg }" :required="true" />
              <small v-if="input.user_id.errMsg" class="p-error">{{ input.user_id.errMsg }}</small>
            </div>
          </div>
          <div class="p-col-12 p-md-6 button-pane">
            <Button v-if="isSubmit" label="Requesting . . ." :disabled="true" />
            <Button v-else label="Request password reset" @click="onSubmit"/>
          </div>
          <div class="p-col-12 p-md-6 link-pane">
            <router-link :to="{ name: 'login' }"><button class="p-link">Back to login</button></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { requestReset } from "@/api/auth.js"

export default {
  name: "ForgotPassword",

  data() {
    return {
      isSubmit: false,
      input: {
        user_id: {
          value: '',
          errMsg: null
        }
      }
    }
  },
  methods: {
    goDashboard() {
      window.location = "app"
    },
    onSubmit() {
      // Form Validation
      let doSubmit = true
      this.input.user_id.errMsg = null

      if (this.input.user_id.value == "" || this.input.user_id.value == null) {
        doSubmit = false
        this.input.user_id.errMsg = "User ID is required"
      }

      // Submit
      if (doSubmit) {
        this.isSubmit = true

        try {
          requestReset(this.input.user_id.value)
            .then((res) => {
              if (res.data.status) {
                this.$toast.add({severity:'success', summary: 'Success', detail: res.data.message, life: 10000})
                this.$session.flash.set("flash-class", "success")
                this.$session.flash.set("flash-message", "Please check your email for reset password link.")
              } else {
                this.$toast.add({severity:'error', summary: 'Error', detail: res.data.message, life: 5000})
              }
            })
            .finally(() => { this.isSubmit = false })
            .catch((e) => {
              if(e.response.status && e.response.status == 422) {
                this.$toast.add({severity:'error', summary: 'Error', detail: e.response.data.message, life: 5000})

                if(e.response.data.errors) {
                  let errObj = e.response.data.errors
                  this.input.user_id.errMsg = errObj.user_id ? errObj.user_id[0] : null
                }
              } else {
                this.$toast.add({severity:'error', summary: 'Error', detail: "Password reset request failed due to network error.", life: 5000})
              }
            })
        } catch (e) {
          console.error(e)
        }
      }
    }
  }
}
</script>

<style scoped>

</style>